import Cookies2 from 'js-cookie';

const Cookies = Cookies2.withConverter({
  write(value: string) {
    return value;
  },
  read(value: string) {
    return value;
  },
});

export const readBrowserStorage = (key: string) => {
  if (typeof window === 'undefined') return null;

  let data;

  if (window.localStorage) {
    data = window.localStorage.getItem(key);
  }

  if (!data) {
    data = Cookies.get(key);
  }

  return data;
};

export const writeBrowserStorage = (
  key: string,
  value: string,
  domain: string = null
) => {
  if (typeof window === 'undefined') return;

  if (window.localStorage) {
    window.localStorage.setItem(key, value);
  }

  if (domain) {
    Cookies.set(key, value, {
      domain,
      sameSite: 'None',
      secure: true,
    });
  } else {
    Cookies.set(key, value);
  }
};
